const Transitions = {
  HoverTextColor: 'color 0.2s ease',
  HoverBackgroundgColor: 'background-color .2s ease',
  AllColor: 'background-color color .2s ease',
};

export { Transitions as transitions };
